import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet"; //metadata manager
import { Button } from "../elements/buttons";
import { Section, Image } from "../elements/bodyComponents";
import { VideoLightbox } from "./videoPlayer";
import { SectionTitle, BodyCopy } from "../typography/typography";
import { RecipePromo } from "../elements/recipes";
import { SocialShare } from "../social/components";
import {
  BuildImagePath,
  ShowPage,
  HidePage,
  ScrollToPosition
} from "../helpers/helpers";

//styles
import "../css/recipes.css";
import "../css/backgrounds.css";

//data
import { Recipes } from "../json/recipes";
import { Products } from "../json/products";
import { Config } from "../json/config";

export class RecipeDetail extends React.Component {
  constructor(props) {
    super(props);
    this.params = this.props.match.params;

    this.getRecipe = this.getRecipe.bind(this);
    this.showVideo = this.showVideo.bind(this);

    this.state = {
      recipe: null,
      product: null,
      activeVideo: null
    };
  }

  /*
        Get Recipe
    */
  getRecipe(name) {
    const recipe = Recipes.find(r => {
      return r.id === name;
    });
    this.setState({
      recipe: recipe,
      product: this.getProduct(recipe.category, recipe.products[0])
    });
  }

  /*
        Get Product
    */
  getProduct(group, name) {
    const groupItems = Products[group];
    return groupItems.items.find(p => {
      return p.id === name;
    });
  }

  showVideo() {
      console.log(this);
      console.log(this.state.recipe.videoURL);
      let videoData = {
          videoURL: this.state.recipe.videoURL,
          videoID: "recipePlayer",
          controls: true,
          autoPlay: true,
      };
      this.setState({
          activeVideo: videoData
      });
  }

  /*
        called when new params are passed to the component, like changing between projects
    */
  componentWillReceiveProps(nextProps) {
    if (this.state.type !== nextProps.match.params.name) {
      ScrollToPosition(0, "smooth");
      this.getRecipe(nextProps.match.params.name);
    }
    this.setState({
        activeVideo: null
    })
  }

  componentWillUnmount() {
    if (document.querySelector(".globalHeader").classList.contains("small")) {
      document.querySelector(".globalHeader").classList.remove("small");
    }
    HidePage();
  }

  /*
        called when component first loads, not called for changes
    */
  componentDidMount() {
    //force logo into small layout
    const header = document.querySelector(".globalHeader");
    if (header.classList.contains("shrinkLogo") === false) {
      header.classList.add("shrinkLogo");
    }
    document
      .querySelector(".globalNav")
      .setAttribute("data-activepage", "recipes");

    ShowPage();

    this.getRecipe(this.params.name);
  }

  render() {
    console.log(this.state);

    const recipe = this.state.recipe;

    if (this.state.recipe !== null && this.state.product !== null) {
      const ingredients = recipe.ingredients.map((i, index) => (
        <p key={index} className="recipe-list-item font-helvetica">
          {i}
        </p>
      ));

      const directions = recipe.directions.map((i, index) => (
        <p key={index} className="recipe-list-item font-helvetica">
          {i}
        </p>
      ));

      let maxAdditionalRecipes = 3;
      if (window.innerWidth > 480 && window.innerWidth < 700) {
        maxAdditionalRecipes = 4;
      }

      const imageSizeArray = [
        {
          w: 480,
          name: "medium"
        },
        {
          w: 800,
          name: "large"
        },
        {
          w: 4000,
          name: "medium"
        }
      ];

      const backgroundImageSizeArray = [
        {
          w: 480,
          name: "small"
        },
        {
          w: 4000,
          name: "large"
        }
      ];

      return (
        <div
          className="layout-recipePage usingMasterCard usingBackgrounds"
          data-product={this.state.product.id}
        >
            { this.state.activeVideo !== null && <VideoLightbox activeVideo={this.state.activeVideo}/> }
          <Helmet>
            <title>{`${Config.title} - ${
              typeof recipe.shortname === "undefined"
                ? recipe.name
                : recipe.shortname
            }`}</title>
            <meta
              name="og:title"
              content={`${
                typeof recipe.shortname === "undefined"
                  ? recipe.name
                  : recipe.shortname
              }`}
            />
            <meta name="og:description" content={recipe.description} />
            <meta name="og:image" content={recipe.image.full} />
            <meta property="og:url" content={window.location.href} />
          </Helmet>
          <header className="pageHeader noHeader">
            <div className="header-background">
              <img
                className="left"
                src={BuildImagePath(
                  `${recipe.category}_${this.state.product.id}_left.png`,
                  "headers",
                  backgroundImageSizeArray
                )}
                alt=""
              />
              <img
                className="right"
                src={BuildImagePath(
                  `${recipe.category}_${this.state.product.id}_${
                    this.state.product.useSameBackgrounds === true
                      ? "left.png"
                      : "right.png"
                  }`,
                  "headers",
                  backgroundImageSizeArray
                )}
                alt=""
              />
            </div>
          </header>

          <Section classes="recipe-detail width-medium masterCard mobileBorder padding-y-large padding-x-large">
            <Link to={`/recipes?category=${recipe.category}`}>
              <Button classes="button-back textOnly" />
            </Link>

            <div className="recipe-row-top flex vertical-center">
              <div className="recipe-image margin-right-large">
                <Image
                  src={BuildImagePath(recipe.image, "recipes", imageSizeArray)}
                  classes="recipe-image-inner"
                  alt={
                    typeof recipe.shortname === "undefined"
                      ? recipe.name
                      : recipe.shortname
                  }
                />
                {typeof recipe.videoURL !== "undefined" && (
                  <div
                    className={"recipe-playVideo recipe-image-inner image-wrap"}
                  >
                    <div className={"playIcon"} onClick={this.showVideo}>
                      PLAY VIDEO
                    </div>
                  </div>
                )}
              </div>

              {/*
                                sizes="(max-width: 1600px) 100vw, 1600px"
                                srcSet="img/fullWidth/recipe_home_large.jpg 2702w, img/fullWidth/recipe_home_medium.jpg 1801w, img/fullWidth/recipe_home_small.jpg 1441w, img/fullWidth/recipe_home_xsmall.jpg 1081w"
                            */}

              <div className="recipe-description color-gray">
                <SectionTitle classes="">{recipe.name}</SectionTitle>
                <BodyCopy classes="margin-top-medium font-helvetica">
                  {recipe.description}
                </BodyCopy>
                <SocialShare
                  classes="margin-top-small"
                  color="red"
                  image={`/img/recipes/large/${recipe.image}`}
                  pageType="recipe"
                  title={recipe.name}
                  desc={recipe.description}
                />
              </div>
              <div className="recipe-info flex flex-wrap">
                <RecipeInfo type="prep" value={recipe.meta.prep} unit="min" />
                <RecipeInfo type="total" value={recipe.meta.total} unit="min" />
                <RecipeInfo
                  type="servings"
                  value={recipe.meta.yield}
                  unit="servings"
                />
              </div>
            </div>

            <div className="recipe-row-bottom flex color-gray">
              <div className="recipe-ingredients padding-x-medium flex">
                <div className="ingredientTextBox">
                  <h4 className="cardTitle uppercase margin-bottom-medium dash-below dash-gray-light dash-large">
                    Ingredients:
                  </h4>
                  {ingredients}
                </div>
                <div className={"productIngredintShow " + recipe.category}>
                  <img
                    class={"bottleShadow"}
                    src={
                      "//foodnetworkkitcheninspirations.com.s3.amazonaws.com/img/recipes/shadow.png"
                    }
                  />
                  <img
                    src={this.state.product.image.full}
                    alt={this.state.product.name}
                    class={"bottleTop"}
                  />
                  <SectionTitle classes="recipeProductTitleShow margin-bottom-medium dash-below dash-center dash-red">
                    {this.state.product.name}
                  </SectionTitle>
                </div>
              </div>

              <div className="recipe-directions padding-x-medium">
                <h4 className="cardTitle uppercase margin-bottom-medium dash-below dash-gray-light dash-large">
                  Directions:
                </h4>
                {directions}
              </div>
            </div>
          </Section>

          <RecipePromo
            category={recipe.category}
            currentRecipe={recipe.id}
            color="red"
            max={maxAdditionalRecipes}
            title={`More Recipes`}
            classes="width-medium masterCard margin-top-large margin-bottom-large padding-x-xlarge"
            URL={`/recipes?category=${recipe.category}`}
          />
        </div>
      );
    } else {
      return <div> loading </div>;
    }
  }
}

class RecipeInfo extends React.Component {
  render() {
    let title = `${this.props.type} Time:`;
    if (this.props.type === "servings") {
      title = `${this.props.type}:`;
    }

    let value = this.props.value;
    let unit = this.props.unit;
    if (this.props.value > 60) {
      value = this.props.value / 60;
      unit = "hours";
    }

    return (
      <div
        className={`recipe-info-component text-align-center color-gray ${
          this.props.type
        }`}
      >
        <h4 className="cardTitle uppercase">{title}</h4>
        <p className="recipe-info-value">
          <span className="value">{value}</span>
          <span className="unit">{unit}</span>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/recipe.js